import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=2dd32a06&"
import script from "./OrderDetailModal.ts?vue&type=script&lang=js&"
export * from "./OrderDetailModal.ts?vue&type=script&lang=js&"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports